module.exports = __webpack_public_path__ + "img/pic_13.113e957b.jpg";